import { Component } from '@angular/core';

@Component({
  selector: 'app-grocy-calendar',
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
})
export class GrocyCalendarComponent {}
